import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA, OBSERVATION_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const SPONSORS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'sponsors',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    bg: BG_SCHEMA(),
    title: TITLE_SCHEMA('Patrocinadores'),
    subtitle: SUBTITLE_SCHEMA(),
    observation: OBSERVATION_SCHEMA()   
  }
}

export const beforeParseSponsors = target => {
  commonBeforeParseMethod(target, ['bg'])
}

export const SPONSORS_SECTION = config => ({
  schema: SPONSORS_SCHEMA(config),
  beforeParse: beforeParseSponsors
})
